/**
 * @namespace ThemeSetter
 * @aka SWRNEU.ThemeSetter
 */
SWRNEU.ThemeSetter = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'themesetter';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'iframe'
  };

  var Default = {};

  var DefaultType = {};

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var ThemeSetter = function () {

    function ThemeSetter(element, config) {
      COMMON.Utils._classCallCheck(this, ThemeSetter);

      var self = this;

      // protected
      self.element = element;
      self.config = self._getConfig(config);
      self.$element = $(self.element);

      self._observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
              //iframe wurde eingefügt
              if (node.nodeName === 'IFRAME') {
                console.log('Neues iframe gefunden:', node);
                self._iframeTheme(node);
              } else if (node.nodeType === Node.ELEMENT_NODE) {
                //iframe wurde nicht direkt, sondern mit einem
                //anderen Container zusammen eingefügt wurde
                const iframes = node.querySelectorAll('iframe');
                iframes.forEach(iframe => {
                  console.log('Neues iframe innerhalb eines Containers gefunden:', iframe);
                  self._iframeTheme(iframe);
                });
              }
            });
          }
        });
      });

      self._observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      self._iframeTheme(self.element);
    }

    /******
     * Um die iframes im aktuellen Theme-Mode
     * anzeigen zu können, braucht es eine
     * Hilfsfunktion, die den aktuellen Mode erkennt
     * und auf den iframe anwendet.
     * @param iframe
     * @private
     */
    ThemeSetter.prototype._iframeTheme = function _iframeTheme(iframe){
      setTheme(iframe);
      watchTheme(iframe);

      function watchTheme(iframe) {
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
          setTheme(iframe);
        });
      }
      function getCurrentTheme(){
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      }
      function setTheme(iframe) {
        const theme = getCurrentTheme();
        console.log(iframe, theme);
        if(iframe.document !== null && typeof iframe.document !== 'undefined') {
          iframe.document.documentElement.dataset.theme = theme;
        }
      }
    };

    // public
    ThemeSetter.prototype.dispose = function dispose() {
      if (this._observer) {
        this._observer.unobserve(this.element);
        this._observer = null;
      }

      $(this.element).off(EVENT_KEY);
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // private
    ThemeSetter.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // static
    ThemeSetter._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if (!data) {
          data = new ThemeSetter(this, _config);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return ThemeSetter;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    ThemeSetter._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      ThemeSetter._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = ThemeSetter._jQueryInterface;
  $.fn[NAME].Constructor = ThemeSetter;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return ThemeSetter._jQueryInterface;
  };

  return ThemeSetter;

})(window.jQuery);
